<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import PostSaleStatusDetailSection from './PostSaleStatusDetailSection.vue';
import {
  laudemiumLabel,
  payloadOf,
  textOf,
} from './postSaleStatusDetailPresenter';

const props = defineProps({ event: { type: Object, required: true } });
const { t } = useI18n();
const section = computed(() => {
  const payload = payloadOf(props.event);
  const entries = payload.laudemio || payload.laudemios || [];
  const empty = t('POST_SALE.COMMON.EMPTY_VALUE');

  return {
    title: t('POST_SALE.STATUS_DETAILS.LAUDEMIUM'),
    badge:
      entries.length === 1
        ? t('POST_SALE.STATUS_DETAILS.ONE_LAUDEMIUM')
        : t('POST_SALE.STATUS_DETAILS.LAUDEMIUM_COUNT', {
            count: entries.length,
          }),
    items: entries.length
      ? entries.map((entry, index) => ({
          label: t('POST_SALE.STATUS_DETAILS.LAUDEMIUM_NUMBER', {
            number: index + 1,
          }),
          value: laudemiumLabel(entry, t) || empty,
        }))
      : [
          {
            label: t('POST_SALE.STATUS_DETAILS.ENTRIES'),
            value: textOf(payload.quant_laudemio, empty, t),
          },
        ],
  };
});
</script>

<template>
  <PostSaleStatusDetailSection v-bind="section" />
</template>
